/* eslint-disable prefer-destructuring */
export const SLACK_BOT_EXPRESS_APP_URL = process.env.SLACK_BOT_EXPRESS_APP_URL;
